class MapController {

  // Usage: single_platform, map

  constructor() {
    this.active = true;

    this.mapElem = document.querySelector('.google-maps');
    this.markerElements = null; 

    this.googleMap = null;
    this.googleMarkers = null;
    this.activeInfoWindow = null;

    this.markerIcon_type1 = null;

    this.settings = {
      // fullscreenControl: false,
      // mapTypeControl: false,
      // streetViewControl: false,
      // zoomControl: true,
      // zoomControlOptions: { position: 10 },
      // maxZoom : 14,
      // keyboardShortcuts: true,
      // clickableIcons: true,
      styles: null,
      center: { lat: 53.1169587, lng: 5.7853763 }, // Center on Friesland
      disableDefaultUI: true,
      zoom: 9
    }

    window.initMap = this.on_init.bind(this);
  }

  on_init() {
    this.set_style();
    this.set_maker_icons();
    this.init_googlemap();
  }

  set_style() {
    this.settings.styles = window.map_style; // geladen in js/core/map-style.js
  }

  set_maker_icons() {
    var svg1 = window.btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
      <g id="Group_10588" data-name="Group 10588" transform="translate(-1461 -1024)">
        <circle id="Ellipse_38" data-name="Ellipse 38" cx="6.5" cy="6.5" r="6.5" transform="translate(1469 1032)" fill="#7e2322"/>
        <g id="Group_10587" data-name="Group 10587" transform="translate(-40 20)">
          <g id="Ellipse_37" data-name="Ellipse 37" transform="translate(1501 1004)" fill="none" stroke="#7e2322" stroke-width="1">
            <circle cx="14.5" cy="14.5" r="14.5" stroke="none"/>
            <circle cx="14.5" cy="14.5" r="14" fill="none"/>
          </g>
        </g>
      </g>
    </svg>
    `);
    this.markerIcon_type1 =  {
      url: `data:image/svg+xml;base64,${svg1}`,
      scaledSize: new google.maps.Size(24, 24),
      anchor: new google.maps.Point(12,12)
    }
  }

  loadWfsGeoJSON() {
    var wfsUrl = 'wp-content/uploads/geodata/gemeentegrenzen.json';

    // Create a Data layer
    var dataLayer = new google.maps.Data({map: this.googleMap});
    dataLayer.setStyle({
      fillColor: '#46C0E3', // Background color
      strokeColor: 'white', // Border color
      strokeWeight: 1.5 // Border thickness
    });

    // Load WFS GeoJSON
    fetch(wfsUrl)
      .then(response => response.json())
      .then((geojsonData) => {
          dataLayer.addGeoJson(geojsonData);
      })
      .catch(error => {
          console.error('Error loading WFS GeoJSON:', error);
      });
  }

  init_googlemap() {
    var self = this;

    if( self.mapElem == null ) return;
    var markerElements = self.mapElem.querySelectorAll('.marker'); // van htmlelements .. 

    // Map
    self.googleMap = new google.maps.Map( self.mapElem, self.settings);

    // Gemeente layer
    self.loadWfsGeoJSON();

    // Makers html -> object
    self.googleMarkers = new Array();
    // var mapBounds = new google.maps.LatLngBounds(); // collection van latlng

    markerElements.forEach( function(markerElem) { // .. naar javascript objects

      let info = JSON.parse(markerElem.getAttribute('data-info'));
      let latlng = new google.maps.LatLng(info.lat, info.lng);

      let icon
      icon = self.markerIcon_type1;

      let markerSettings = {
        position : latlng,
        map : self.googleMap,
        label : '',
        zIndex : 1,
        icon: icon
      };

      let marker = new google.maps.Marker(markerSettings);
      marker.info = info; // data bij marker opslaan

      // Add to map and coordinates to bounds
      self.googleMarkers.push(marker);
      // mapBounds.extend(latlng);

      // Info window
      // if( markerElem.innerHTML != '' ) {
      //   var infoWindow = new google.maps.InfoWindow({
      //     content: markerElem.innerHTML
      //   });

      //   google.maps.event.addListener(marker, 'click', function (e) {
      //     if (self.activeInfoWindow != null ) self.activeInfoWindow.close();
      //     self.activeInfoWindow = infoWindow;
      //     infoWindow.open(self, marker);

      //     let event = new CustomEvent('marker_clicked', {
      //       detail : {id : marker.info.id }
      //     });
      //     window.dispatchEvent(event);
      //   });

      //   google.maps.event.addListener(infoWindow,'closeclick',function(){
      //     let event = new CustomEvent('close_infowindow', {
      //       detail : {post : marker.info.post }
      //     });
      //     window.dispatchEvent(event);
      //   });

      // }
    }); // / foreach

    // this.googleMap.setCenter(mapBounds.getCenter());
    // this.googleMap.fitBounds(mapBounds);
  }

}